import { useReturnNavigation } from "../../../app/navigation/return-navigation.js";
import { PageHeading } from "@peer-start/ui";
import { BackLink } from "../../../app/components/BackLink.js";
import { BrainCircuit } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../app/use-app-context.js";
import { usePassportPage } from "../api/queries.js";
import { AreaAssessmentConversation } from "../components/AreaAssessmentConversation.js";
import { PassportQueryState } from "../components/PassportQueryState.js";

export function LegacyAreaAssessmentPage() {
  const { t } = useTranslation();
  const { pageId = "" } = useParams();
  const { persona } = useAppContext();
  const back = useReturnNavigation(`/me/passport/${pageId}`);
  const query = usePassportPage(persona.kind === "employee" ? persona.id : "", pageId);
  return (
    <div className="mx-auto max-w-3xl">
      <BackLink controlId="area-assessment.back" to={back.to}>
        {t(back.labelKey)}
      </BackLink>
      <PassportQueryState
        error={query.isError}
        loading={query.isLoading}
        onRetry={() => void query.refetch()}
      >
        {query.data ? (
          <>
            <PageHeading
              title={query.data.summary.page.title}
              subtitle={t("areaAssessment.subtitle")}
              eyebrow={
                <>
                  <BrainCircuit aria-hidden="true" className="size-5" />
                  {t("areaAssessment.eyebrow")}
                  <span className="rounded-full bg-warning px-2 py-1 text-[10px] text-warning-foreground">
                    {t("areaAssessment.demo")}
                  </span>
                </>
              }
            />
            <div className="mb-6 flex flex-wrap gap-2" aria-label={t("areaAssessment.topics")}>
              {query.data.stamps
                .filter((item) => item.applicability !== "out_of_scope")
                .map(({ stamp }) => (
                  <span
                    className="rounded-full border border-border bg-muted/20 px-3 py-1 text-xs text-muted-foreground"
                    key={stamp.id}
                  >
                    {stamp.shortTitle}
                  </span>
                ))}
            </div>
            <AreaAssessmentConversation
              key={`${persona.id}:${pageId}`}
              area={query.data.summary.page.title}
              pageId={pageId}
            />
          </>
        ) : null}
      </PassportQueryState>
    </div>
  );
}
